import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'customFilter',
    standalone: false
})
export class CustomFilterPipe implements PipeTransform {

  transform(items: any[], searchText: string, properties: string[]): any[] {
    if(!items || !searchText || searchText.length < 3 || !properties || properties.length === 0) {
      return items;
    }

    searchText = searchText.toLowerCase();

    //Filter based on the propeties param
    return items.filter(item => this.matchesSearchTerm(item, searchText, properties));
  }
  
  matchesSearchTerm(item: any, searchTerm: string, properties: string[]): boolean {
    return properties.some(property => {
      const value = item[property] ;
      if (Array.isArray(value)) {
        // If property value is an array, check if the searchTerm is included in any of its elements
        for (let i = 0; i < value.length; i++) {
          if (value[i].toLowerCase().includes(searchTerm)) {
            return true;
          }
        }
        return false;
      } else {
        // If not an array, convert value to lower case and check if it includes searchTerm
        return value && value.toLowerCase().includes(searchTerm);
      }
    });
  }
}
